(function () {
    'use strict';

    angular.module('processModule')
        .controller('process-hearing-view.controller', processHearingViewController);

    processHearingViewController.$inject = ['$stateParams', 'routeService', '$sce'];
    function processHearingViewController($stateParams, routeService, $sce) {
        var vm = this;
        vm.initialize = initialize;
        vm.processNumber = $stateParams.processNumber
        vm.version = $stateParams.version;
        vm.processHearingViewFrame = '';

        initialize();

        function initialize() {
            vm.processHearingViewFrame = $sce.trustAsResourceUrl(routeService.getBaseRouteProcess() + `process-detail/viewsendtohearing/${vm.processNumber}/${vm.version}?isFrontend=true`);
        }
    };

})();

